import * as React from 'react';
export const useSafeContext = (context) => {
  let value = React.useContext(context);
  if (!value)
    throw new Error(`${context.displayName || 'Context'} is undefined`);
  return value;
};
